export class Lookup {
  id!: number;
  name!: string;
  childs?: Lookup[];
  isUsed?: boolean;
  isdisabled?: boolean;
  isdefault?: boolean;
  lookupcode?: string
  lookupCode!: string
  lookUpCode?: string
  icon?: string
  nameAr?: string
  nameEn!: string
  gateWayType?: string
  sourceType!: string
  isExpiryDateRequired!: boolean
  fifoMode!: string
}
export class Currency {
  id!: number;
  name!: string;
  nameEn!: string;
  nameAr!: string;
  currencyCode!: string;
  currencyCodeEn!: string;
  currencyCodeAr!: string;
  conversionRate!: number | null;
  conversionRateValid?: boolean | null;
  isDefault!: boolean;
  order!: number;
}

export class Countries {
  id!: number;
  name!: string;
  countryKey!: string;
  countryFlag!: string;
  isdefault!: boolean;
}

export class FileThumbObj {
  id!: number;
  file: any
  thumbStr!: string
  thumb: any
  thumbType!: FileThumbType
}

export enum FileThumbType {
  Generated = 'Generated',
  Uploaded = 'Uploaded'
}
export enum AppsSettingUrlEnum {
  CashierPrivacyPolicy = 'CashierPrivacyPolicy',
  CashierTermsAndConditions = 'CashierTermsAndConditions',
  CustomerPrivacyPolicy = 'CustomerPrivacyPolicy',
  CustomerTermsAndConditions = 'CustomerTermsAndConditions',
}
export enum OrderTypeEnum {
  All = 'All',
  DineIn = 'DineIn',
  Takeaway = 'Takeaway'
}

export enum ApplyDiscountEnum {
  Orders = 'Orders',
  Items = 'Items'
}
